module.exports = __webpack_public_path__ + "mainassets/img/form3-cutting.2290a964.svg";